/**
 * IntelliGems A/B Test — Cart drawer sticky layout
 *
 * Control (A): data-cart-drawer-sticky="false"
 * Variant (B): data-cart-drawer-sticky="true"
 * Dev: ?cart_drawer_sticky_test=b
 *
 * Variant: sticky subtotal/checkout, scrollable addons, compact
 * single-line shipping insurance above checkout, image zoom, etc.
 */
(function () {
  'use strict';

  if (window.__cartDrawerStickyABTestInit) return;
  window.__cartDrawerStickyABTestInit = true;

  var BODY_ATTR = 'data-cart-drawer-sticky';
  var SHORT_TITLE = 'Shipping insurance';
  var moving = false;

  function isTruthy(value) {
    var n = String(value || '')
      .trim()
      .toLowerCase();
    return n === 'true' || n === '1' || n === 'on' || n === 'yes';
  }

  function isDevVariantB() {
    try {
      return (
        new URLSearchParams(window.location.search).get(
          'cart_drawer_sticky_test'
        ) === 'b'
      );
    } catch (e) {
      return false;
    }
  }

  function isVariantB() {
    if (isDevVariantB()) return true;
    var body = document.body;
    return !!(body && isTruthy(body.getAttribute(BODY_ATTR)));
  }

  function applyDev() {
    if (!isDevVariantB() || !document.body) return;
    if (!isTruthy(document.body.getAttribute(BODY_ATTR))) {
      document.body.setAttribute(BODY_ATTR, 'true');
    }
  }

  function isInsuranceNode(el) {
    if (!el || !el.getAttribute) return false;
    if (el.getAttribute('data-shipping-insurance') === 'true') return true;
    if (el.classList && el.classList.contains('upsell--shipping-insurance')) {
      return true;
    }
    var handle = (el.getAttribute('data-handle') || '').toLowerCase();
    var titleEl = el.querySelector && el.querySelector('.upsell__title h3');
    var titleText = titleEl ? (titleEl.textContent || '').toLowerCase() : '';
    return (
      handle.indexOf('insured') !== -1 ||
      handle.indexOf('insurance') !== -1 ||
      titleText.indexOf('shipping insurance') !== -1
    );
  }

  function compactInsurance(el) {
    el.classList.add('upsell--shipping-insurance');
    el.setAttribute('data-shipping-insurance', 'true');
    var title = el.querySelector('.upsell__title h3');
    if (title) {
      var link = title.querySelector('a');
      if (link) link.textContent = SHORT_TITLE;
      else title.textContent = SHORT_TITLE;
    }
    var desc = el.querySelector('.upsell__desc');
    if (desc) desc.remove();
  }

  function placeStickyInsurance() {
    if (!isVariantB() || moving) return;

    var drawer =
      document.querySelector('#CartDrawer') ||
      document.querySelector('cart-drawer');
    if (!drawer) return;

    var footer = drawer.querySelector('.drawer__footer');
    var checkoutWrap = footer && footer.querySelector('.cart__ctas');
    if (!footer || !checkoutWrap) return;

    var candidates = drawer.querySelectorAll(
      'cart-drawer-upsell, .upsell, [data-handle], [data-shipping-insurance]'
    );
    var insurance = null;

    candidates.forEach(function (node) {
      if (!isInsuranceNode(node)) return;
      compactInsurance(node);
      if (!insurance) {
        insurance = node;
      } else if (node !== insurance && node.closest('.cart-drawer__body')) {
        /* keep sticky/footer copy; leave body copy for CSS hide */
        return;
      } else if (node !== insurance && node.closest('.drawer__footer')) {
        if (insurance.closest('.drawer__footer')) {
          node.remove();
        } else {
          insurance = node;
        }
      }
    });

    if (!insurance) return;

    if (
      insurance.parentElement !== footer ||
      insurance.nextElementSibling !== checkoutWrap
    ) {
      moving = true;
      footer.insertBefore(insurance, checkoutWrap);
      moving = false;
    }

    drawer.querySelectorAll('.cart-drawer-upsells--sticky').forEach(function (
      wrap
    ) {
      if (!wrap.querySelector('.upsell, cart-drawer-upsell')) wrap.remove();
    });
  }

  function run() {
    applyDev();
    placeStickyInsurance();
  }

  document.addEventListener('DOMContentLoaded', run);
  document.addEventListener('cart:updated', run);
  document.addEventListener('cart-drawer:updated', run);

  var root = document.querySelector('cart-drawer');
  if (root && window.MutationObserver) {
    var timer = null;
    new MutationObserver(function () {
      if (!isVariantB()) return;
      clearTimeout(timer);
      timer = setTimeout(placeStickyInsurance, 60);
    }).observe(root, { childList: true, subtree: true });
  }

  if (document.body) applyDev();
  run();
})();
